import {
  isConstantNode,
  isOperatorNode,
  isParenthesisNode,
  MathNode
} from "mathjs";

import { flattenCommutative } from "./exprEquality/structEqual";
import { constant, getNodeChildren, multiply } from "./operations";

export function removeParentheses(node: MathNode): MathNode {
  if (isParenthesisNode(node)) {
    return removeParentheses(node.content);
  }
  return node.map(removeParentheses);
}

export function allImplicit(node: MathNode): MathNode {
  if (isOperatorNode(node)) {
    const newNode = node.cloneDeep();

    if (node.op === "*") {
      const flattenedChildren = getNodeChildren(flattenCommutative(node));
      if (
        isConstantNode(flattenedChildren[0]) &&
        isConstantNode(flattenedChildren[1])
      ) {
        newNode.implicit = false;
      } else {
        newNode.implicit = true;
      }
    } else {
      newNode.implicit = true;
    }

    return newNode.map(allImplicit);
  }
  return node.map(allImplicit);
}

// from unaryMinus(1) to just -1
export function applyMinus(node: MathNode): MathNode {
  function applyMinusHelper(node: MathNode, sign: number): MathNode {
    if (isOperatorNode(node) && node.fn === "unaryMinus") {
      return applyMinusHelper(node.args[0], -sign);
    }

    if (isConstantNode(node)) {
      const newNode = node.cloneDeep();
      newNode.value *= sign;
      return newNode;
    }

    if (sign === 1 || (isOperatorNode(node) && node.fn === "add")) {
      return node.map(childNode => applyMinusHelper(childNode, sign));
    }

    // below the sign will always be -1 because of the above condition

    if (isOperatorNode(node) && node.fn === "multiply") {
      const nodeChildren = node.args;
      const constNodeId = nodeChildren.findIndex(isConstantNode);
      if (constNodeId !== -1) {
        const newNode = node.cloneDeep();
        newNode.args = nodeChildren.map((childNode, childId) =>
          applyMinusHelper(childNode, constNodeId === childId ? -1 : 1)
        );
        return newNode;
      }
    }

    return multiply(
      constant(-1),
      node.map(childNode => applyMinusHelper(childNode, 1))
    );
  }

  return applyMinusHelper(node, 1);
}
